import { render } from "./3.vue?vue&type=template&id=9848fc9e&scoped=true"
import script from "./3.vue?vue&type=script&lang=js"
export * from "./3.vue?vue&type=script&lang=js"

import "./3.vue?vue&type=style&index=0&id=9848fc9e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9848fc9e"]])

export default __exports__